import { createSignal, onMount } from 'solid-js'
import { res2json } from '@/utils'
import { addToast } from '@/components/Toast'
import account from '@/store/account'

export function EditPasswordDialog() {
  const [oldPassword, setOldPassword] = createSignal('')
  const [password, setPassword] = createSignal('')
  const [confirmPassword, setConfirmPassword] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus

  onMount(() => {
    new MutationObserver((e) => {
      if (e[0].target.open) {
        setOldPassword('')
        setPassword('')
        setConfirmPassword('')

        setErrors({})
        elFocus.focus()
      }
    }).observe(window.editPassword, { attributes: true })
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/password', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        old_password: oldPassword(),
        password: password(),
        confirm_password: confirmPassword()
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        addToast({ message: '密码已修改成功' })
        window.editPassword.close()
      }
    }).finally(() => { setSending(false) })
  }

  function cancel() {
    window.editPassword.close()
  }

  return (
    <dialog id="editPassword" class="modal">
      <form onSubmit={submit} class="flex flex-col gap-6 w-full max-w-sm px-4 lg:px-0">
        <button type="button" onClick={() => cancel()} class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" disabled={sending()}>✕</button>
        <h3 class="text-lg">修改密码</h3>
        <div class="form-control">
          <div class="label"><span class="label-text">旧登陆密码</span></div>
          <input ref={elFocus} type="password" value={oldPassword()} onChange={e => setOldPassword(e.target.value)} class="input input-bordered" placeholder="请输入旧的登陆密码" required />
          {errors().old_password && (<div class="label"><span class="label-text-alt text-error">{errors().old_password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">新登陆密码</span></div>
          <input type="password" value={password()} onChange={e => setPassword(e.target.value)} class="input input-bordered" placeholder="请输入新的登陆密码" required />
          {errors().password && (<div class="label"><span class="label-text-alt text-error">{errors().password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">确认新登陆密码</span></div>
          <input type="password" value={confirmPassword()} onChange={e => setConfirmPassword(e.target.value)} class="input input-bordered" placeholder="请确认新的登陆密码" required />
          {errors().confirm_password && (<div class="label"><span class="label-text-alt text-error">{errors().confirm_password}</span></div>)}
        </div>
        {errors().default && (<div class="text-error">{errors().default}</div>)}
        <div class="modal-action flex gap-4">
          <button type="button" onClick={() => cancel()} class="btn px-8" disabled={sending()}>取消</button>
          <button type="submit" class="btn btn-success text-white px-8" disabled={sending()}>确定</button>
        </div>
      </form>
    </dialog>
  )
}

export function ResetPassword() {
  const [oldPassword, setOldPassword] = createSignal('')
  const [password, setPassword] = createSignal('')
  const [confirmPassword, setConfirmPassword] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus
  onMount(() => elFocus.focus())

  async function logout() {
    return fetch('/api/logout').finally(() => {
      document.location.href = `/login/${account().game_code}`
    })
  }

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/password', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        old_password: oldPassword(),
        password: password(),
        confirm_password: confirmPassword(),
        newly_registered: true,
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        document.location.reload()
      }
    }).finally(() => { setSending(false) })
  }

  return (
    <div class="fixed inset-0 flex items-center justify-center">
      <form onSubmit={submit} class="flex flex-col gap-6 w-full max-w-sm px-4 lg:px-0">
        <h1 class="text-2xl">首次登陆，请修改密码</h1>
        <div class="form-control">
          <div class="label"><span class="label-text">旧登陆密码</span></div>
          <input ref={elFocus} type="password" value={oldPassword()} onChange={e => setOldPassword(e.target.value)} class="input input-bordered" placeholder="请输入旧的登陆密码" required />
          {errors().old_password && (<div class="label"><span class="label-text-alt text-error">{errors().old_password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">新登陆密码</span></div>
          <input type="password" value={password()} onChange={e => setPassword(e.target.value)} class="input input-bordered" placeholder="请输入新的登陆密码" required />
          {errors().password && (<div class="label"><span class="label-text-alt text-error">{errors().password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">确认新登陆密码</span></div>
          <input type="password" value={confirmPassword()} onChange={e => setConfirmPassword(e.target.value)} class="input input-bordered" placeholder="请确认新的登陆密码" required />
          {errors().confirm_password && (<div class="label"><span class="label-text-alt text-error">{errors().confirm_password}</span></div>)}
        </div>
        {errors().default && (<div class="text-error">{errors().default}</div>)}
        <div class="flex items-center gap-4">
          <button type="button" onClick={() => logout()} class="btn flex-1" disabled={sending()}>取消</button>
          <button type="submit" class="btn btn-success text-white flex-1" disabled={sending()}>确定</button>
        </div>
      </form>
    </div>
  )
}
